export default "__VITE_ASSET__D4P9Cj6V__"